/**
 * Swaps the locale segment of a pathname (`/{locale}/...` or
 * `/{region}/{locale}/...`) from currentLocale to nextLocale, preserving
 * everything else in the path. Shared by Navbar.tsx and DashboardTopBar.tsx,
 * which previously each defined a byte-for-byte-identical copy of this
 * function.
 *
 * Locale-list-agnostic by design: it only needs to know which segment
 * currently equals currentLocale, not the full set of valid locale codes.
 */
export function getLocalizedPathname(
  pathname: string,
  currentLocale: string,
  nextLocale: string,
): string {
  const segments = pathname.split("/");

  if (segments[1] === currentLocale) {
    segments[1] = nextLocale;
  } else if (segments[2] === currentLocale) {
    segments[2] = nextLocale;
  } else {
    if (pathname === `/${currentLocale}`) return `/${nextLocale}`;
    if (pathname.startsWith(`/${currentLocale}/`))
      return pathname.replace(`/${currentLocale}`, `/${nextLocale}`);
    return `/${nextLocale}${pathname.startsWith("/") ? pathname : `/${pathname}`}`;
  }

  return segments.join("/");
}
